<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <BaseModal
    v-cloak
    :modal-id="`closeDialogModal-${dialogGlobalId}`"
    :header-text="$t('End conversation')"
    :cancel-button-text="$t('Cancel')"
    :action-button-text="$t('End')"
    :confirm-button-text="$t('End conversation')"
    :is-open="open"
    :saving-text="$t('Ending conversation...')"
    :save-state="modalSaveState"
    @cancel="resetModal"
    @positive-response="closeDialog"
    @negative-response="resetModal"
  >
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseHtmlForm accept-charset="UTF-8" append-user-and-account>
      <br />
      <p>
        {{ $t('Consider writing a message when you end the conversation') }}
      </p>
      <textarea
        id="textarea-message"
        v-model="closeMessage"
        :placeholder="$t('Type your message.')"
        name="message"
        class="form-control"
        rows="3"
      ></textarea>
      <div class="checkbox">
        <label>
          <input
            v-model="useAsDefaultMessage"
            type="checkbox"
            name="use_as_defaultmessage"
            class=""
          />
          {{
            $t('Save as :new standard answer', {
              new: defaultCloseMessage ? $t('new') : '',
            })
          }}
          <i class="input-helper"></i>
        </label>
      </div>
    </BaseHtmlForm>
  </BaseModal>
</template>

<script>
import gql from 'graphql-tag'
import { ModalSaveState } from '@/utils/enum'
import { BASE_FRAGMENT_FOR_DIALOG_MUTATIONS } from '@/state/apollo/fragments'
import { NetworkError, Message } from '@/utils/notification'

/**
 * @emits success
 * @emits modal-closed
 */
export default {
  props: {
    dialogGlobalId: { type: String, required: true },
    open: { type: Boolean, default: false },
    defaultCloseMessage: { type: String, default: null },
  },

  data() {
    return {
      modalSaveState: null,
      useAsDefaultMessage: false,
      closeMessage: null,
    }
  },

  watch: {
    useAsDefaultMessage() {
      window.onbeforeunload = null
    },
  },

  mounted() {
    this.closeMessage = this.defaultCloseMessage
  },

  methods: {
    async closeDialog() {
      this.modalSaveState = ModalSaveState.SAVING
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation CloseDialog($input: CloseDialogInput!) {
              closeDialog(input: $input) {
                ...BaseFragmentForDialogMutations
                dialogType
                hasRecruiter
                freelancer {
                  globalId
                  name
                }
                recruiter {
                  globalId
                  name
                }
              }
            }
            ${BASE_FRAGMENT_FOR_DIALOG_MUTATIONS}
          `,
          variables: {
            input: {
              globalId: this.dialogGlobalId,
              message: this.closeMessage,
              useAsDefaultMessage: this.useAsDefaultMessage,
            },
          },
        })
        .then(({ data }) => {
          this.$emit('modal-closed')
          this.$emit('success')
          this.modalSaveState = ModalSaveState.SAVED
          this.modalOpen = false

          const name = data.closeDialog.hasRecruiter
            ? data.closeDialog?.recruiter?.name
            : data.closeDialog?.freelancer?.name

          new Message(
            $t('Closed conversation with :name', {
              name,
            }),
          ).dispatch(this)
        })
        .catch((exception) => {
          this.modalSaveState = ModalSaveState.FAILED
          new NetworkError({
            msg: this.$t('Error occurred. The action was not completed'),
            ex: exception,
          }).dispatch(this)
        })
    },
    resetModal() {
      this.modalOpen = false
      this.$emit('modal-closed')
      this.useAsDefaultMessage = false
    },
  },
}
</script>
